import { useEffect, useRef, useState } from "react";

const DropDown = ({ trigger, items = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownWidth, setDropdownWidth] = useState(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const buttonRef = useRef();

  useEffect(() => {
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      console.log(buttonRect.width);
      setDropdownWidth(buttonRect.width);
    }
  }, []);
  return (
    <div className="relative">
      <button
        ref={buttonRef}
        type="button"
        onClick={toggleDropdown}
        className="inline-flex items-center gap-x-1 text-md leading-6"
        aria-expanded="false"
      >
        <span>{trigger}</span>
      </button>
      <>
        {isOpen && (
          <div
            className="fixed inset-0 opacity-25 z-40"
            onClick={() => setIsOpen(false)} // Clicking on the backdrop closes the dropdown
          ></div>
        )}
        <div
          className={`menu-panel absolute left-1/2 flex min-w-[175px] max-w-max ${
            isOpen ? "z-40" : "-z-40"
          } -translate-x-1/2 px-4
        transition ${
          isOpen
            ? "ease-out opacity-100 translate-y-0 duration-250"
            : "ease-in opacity-0 translate-y-1 duration-200"
        } 
        `}
        >
          <div
            style={{ width: dropdownWidth ? `${dropdownWidth}px` : "180px" }}
            className="max-w-md flex-auto overflow-hidden rounded-md bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5"
          >
            <div>
              {items.map((_item) => (
                <p
                  onClick={() => setIsOpen(false)}
                  className="text-md text-gray-900 hover:bg-gray-200 rounded-md cursor-pointer"
                >
                  {_item}
                </p>
              ))}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default DropDown;
